import {
  GET_TSN_TRANSACTIONS_LOADING,
  GET_TSN_TRANSACTIONS_SUCCESS,
  GET_TSN_TRANSACTIONS_FAILD,
  REMOVE_TSN_TRANSACTION,
} from "../types";

const initialState = {
  transactions: null,
  loading: null,
  error: null,
};

export const getTsnTransactionsReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case GET_TSN_TRANSACTIONS_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case GET_TSN_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        transactions: action.payload,
      };
    case GET_TSN_TRANSACTIONS_FAILD:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case REMOVE_TSN_TRANSACTION:
      return initialState;
    default:
      return state;
  }
};
